import { useContext } from "react";
import AuthContext from "../../context/auth/AuthContext";

// Custom hook to access auth context anywhere in the app
// Usage: const { user, login, logout, hasRole } = useAuth();
const useAuth = () => {
  const context = useContext(AuthContext);

  if (!context) {
    throw new Error("useAuth must be used inside AuthProvider");
  }

  return context;
};

export default useAuth;